<template>
  <div class="area-lance">
    <ModalHAbilitacaoExtra @fechaModalLiberacaoExtra="fechaModalLiberacaoExtra" :info="info" :abre-fecha="abreModal"/>
    <div class="product-info" style="margin-top: -10px; margin-bottom: 10px">
      <Countdown :statuslote_id="statusLote.statuslote" :deadline="dt_fechamento_lote"/>
    </div>
    <!-- {{statusLote}} -->
    <div class="product-info">
      <div class="product-info lote-info" v-if="leilao.statusleilao_id != 17">
        <span class="product-info__lote-info">
          <small>Lances:</small>
          {{ historicoLances }}

          <small>Visitas:</small>
          {{ lote.nu_visitas }}

          <small>Incremento:</small>
          {{ $root.formatarPreco(lote.raw_incremento) }}
        </span>
      </div>
    </div>
    <div class="header-area-lance">
      <h1 ref="titleLength" v-html="lote.nm_titulo"></h1>
    </div>
    <div class="inline-flex">
      <div class="box-heart">
        <div class="add-favorito-novo" title="Adicionar aos favoritos">
          <span v-if="usuario.id != null" :class="`fa ${isfavorito ? 'fa-heart' : 'fa-heart-o'}`"
                @click="addFavorito"></span>
        </div>
      </div>
      <div @click="showShare = !showShare" class="pointer box box-circle" title="Compartilhar">
        <img src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/geral/imagens/icon-share.svg"
             height="20" width="20"/>
      </div>
      <div class="share-buttons" :class="{ 'share-buttons-on': showShare }">
        <leilao-social :title="lote.nm_titulo" :description="lote.descricao" :url="getLink()"/>
      </div>
    </div>
    <div class="body-area-lance row">
      <div class="col-xs-8">
        <h1 ref="precoLength" class="title-header-area hasPortions">
          {{ $root.formatarPreco(lanceAtual.vl_lance) }}
        </h1>
        <p class="portion" v-show="historicoLances > 0">
          {{
            lanceAtual.nu_parcelas && lanceAtual.nu_parcelas > 1
              ? `Parcelado em ${lanceAtual.nu_parcelas}x`
              : "à vista"
          }}
        </p>
      </div>
      <!-- Exibição de Avaliação e valor de desconto caso esteja configurado na criação do leilão -->
      <div v-if="lote.vl_lanceminimo > 0">
        <div class="col-xs-12">
          <div v-if="leilao.bn_exibeavaliacao">
            <span v-if="lote.vl_lanceminimo > 0" class="vl-avaliacao">
              Avaliação: {{ $root.formatarPreco(lote.vl_lanceminimo) }}
            </span>
            <br/>
          </div>
          <div class="vl-lanceinicial" v-if="leilao.bn_exibedesconto">
            <span v-if="lote.vl_lanceinicial > 0">
              Lance mínimo atual: {{ $root.formatarPreco(lote.vl_lanceinicial) }}
            </span>
          </div>
          <div v-if="diferencaPercentual > 0 && leilao.leilao_id_primeiroleilao == null"
               class="base_desconto_segundoleilao">
            <span
              v-html="`Lance mínimo próxima etapa: ${$root.formatarPreco(lote.vistoria[0].vl_lanceinicialsegundoleilao)}`"/>
          </div>
        </div>
      </div>

      <div class="col-xs-8 text-left" style="position: relative">
        <div class="comissao-arrematante">
          Comissão leiloeiro(a): {{
            lote.vistoria && lote.vistoria.length > 0 ? parseFloat(lote.vistoria[0].nu_comissaoarrematantelote) : 'N/A'
          }}%
        </div>
        <div class="lance-atual-header">
          <div v-if="lanceAtual.nm_apelido" style="display: flex">
            Usuário: <strong style="margin-left: 5px">{{ lanceAtual.nm_apelido }}</strong>
          </div>
        </div>
      </div>
      <!-- ENVIO DE LANCE -->
      <div v-if="
        leilao.statusleilao_id !== 1 &&
        leilao.statusleilao_id !== 5 &&
        leilao.statusleilao_id !== 8
      " class="envio-area-lance">
        <div class="row">
          <div class="col-lg-8">
            <!-- LANCE MANUAL -->
            <div v-if="leilao.statusleilao_id !== 13" class="lance-input-group add-label-lance add-label-manual">
              <div class="col-xs-8 container-input-lance">
                <input value="" v-money="money" id="enviar_lance_manual_val" class="input-manual add-label-lance"
                       @keyup="qtdParcelas = 1; calcParcelamento(lote)"/>
              </div>
              <div class="col-xs-4 container-btn-lance">
                <button
                  v-if="statusLote.statuslote == 'Vendido' || (leilao.statusleilao_id == 1 || leilao.statusleilao_id == 5 || leilao.statusleilao_id == 8)"
                  id="enviar_lance_manual" class="btn-lance btn-lance-input" disabled="disabled" style="
                    cursor: pointer;
                    background: #515151 !important;
                    cursor: no-drop;
                  ">
                  Ok
                </button>
                <button v-else id="enviar_lance_manual" class="btn-lance btn-lance-input"
                        @click="enviarLance(true, 'lance')" :disabled="!liberado || !liberacao_lote" :style="'cursor:pointer;' +
                    (!liberado || !liberacao_lote
                      ? 'background: #515151 !important;cursor:no-drop;'
                      : '')
                    ">
                  Ok
                </button>
              </div>
              <div class="clearfix"></div>
            </div>
            <div v-else class="lance-input-group add-label-lance add-label-manual">
              <!--Enviar lance de Venda direta-->
              <div class="col-xs-8 container-input-lance">
                <input value="" v-money="money" id="enviar_lance_manual_val" class="input-manual add-label-lance"
                       @keyup="qtdParcelas = 1; calcParcelamento(lote)"/>
              </div>
              <div class="col-xs-4 container-btn-lance">
                <button
                  v-if="statusLote.statuslote == 'Vendido' || (leilao.statusleilao_id == 1 || leilao.statusleilao_id == 5 || leilao.statusleilao_id == 8)"
                  id="enviar_lance_manual" class="btn-lance btn-lance-input" disabled="disabled" style="
                    cursor: pointer;
                    background: #515151 !important;
                    cursor: no-drop;
                  ">
                  Ok
                </button>
                <button v-else id="enviar_lance_manual" class="btn-lance btn-lance-input"
                        @click="enviarLance(true, 'venda_direta')" :disabled="!liberado || !liberacao_lote" :style="'cursor:pointer;' +
                    (!liberado || !liberacao_lote
                      ? 'background: #515151 !important;cursor:no-drop;'
                      : '')
                    ">
                  Ok
                </button>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div v-if="leilao.statusleilao_id !== 13">
            <div class="col-lg-4 col-padding-lance">
              <span class="label-span-help">Enviar lance</span>
            </div>
          </div>
          <div v-else>
            <div class="col-lg-4 col-padding-lance">
              <span v-if="paramsite_proposta.bn == true" class="label-span-help">Lance Condicional</span>
              <span v-else class="label-span-help">Venda Direta</span>
            </div>
          </div>
          <div class="col-lg-12 col-md-12" v-if="tipoParcelamento">
            <div v-if="
              leilao.bn_aceitelanceparcelado ||
              lote.bn_aceitelanceparceladolote
            " class="nm-parcelas">
              <label>
                Parcelas
                <select v-model="qtdParcelas" id="limite_parcelas" style="width: 119px; padding: 5px; margin-right: 6px"
                        @mouseover="calcParcelamento(lote)">
                  <option v-for="(parcela, idx) in parcelamento" :key="idx"
                          :value="parcela">
                    {{ parcela == 1 ? "à vista" : parcela }}
                  </option>
                </select>
                <div v-if="qtdParcelas > 1" class="parcelas-container">
                  <label for="percentualEntrada" class="percentual-label">Entrada</label>
                  <div class="percentual-input-container">
                    <button type="button" @click="decrementarPercentual" class="percentual-btn"
                            :disabled="lote.nu_intervaloparcelaslote !== 5">
                      -
                    </button>
                    <input type="number" id="percentualEntrada" v-model.number="lote.nu_limitepercentuallote"
                           :min="lote.nu_limitepercentuallote" step="0.5" class="percentual-input" readonly/>
                    <button type="button" @click="incrementarPercentual" class="percentual-btn"
                            :disabled="lote.nu_intervaloparcelaslote !== 5">
                      +
                    </button>
                    <span class="percentual-sufix">%</span>
                  </div>
                </div>
                <div v-if="lote.nm_indicecorrecao" class="indice-correcao-container">
                  <span class="indice-correcao-text">Índice de correção: {{ lote.nm_indicecorrecao }}</span>
                </div>

              </label>
            </div>
            <div v-else>
              <div v-if="
                leilao.bn_aceitelanceparcelado ||
                lote.bn_aceitelanceparceladolote || tipoParcelamento
              " class="nm-parcelas">
                <label>
                  Parcelas
                  <select v-model="qtdParcelas" id="limite_parcelas"
                          style="width: 119px; padding: 5px; margin-right: 6px">
                    <option v-for="(parcela, idx) in leilao.nu_limiteparcelas" :key="idx" :value="parcela">
                      {{ parcela == 1 ? "à vista" : parcela }}
                    </option>
                  </select>
                  <small v-if="qtdParcelas > 1" style="float: right; margin-top: 8px">{{ leilao.nu_limitepercentual }} %
                    de entrada</small>
                </label>
              </div>
              <div v-else></div>
            </div>
          </div>
          <div style="float: right" class="col-xs-5" v-if="
            lanceAtual.nu_parcelas > 1 &&
            (lote.nu_intervaloparcelaslote == 1 ||
              lote.nu_intervaloparcelaslote == 2 ||
              lote.nu_intervaloparcelaslote == 4)
          ">
            <button id="enviar_lance_manual" class="btn-lance btn-lance-input" @click="igualarLanceAtual()"
                    :disabled="!liberado || !liberacao_lote" :style="'background-color: #671c01;' +
                'border-radius: 8px;' +
                'font-size: 12px!important;' +
                'cursor:pointer;' +
                (!liberado || !liberacao_lote
                  ? 'background: #515151 !important;cursor:no-drop;'
                  : '')
                ">
              Igualar à vista
            </button>
            <span style="font-size: 11px"><span style="color: red">À vista</span> no valor de
              <strong>{{
                  $root.formatarPreco(lanceAtual.vl_lance)
                }}</strong></span>
          </div>
          <div class="col-lg-8">
            <!-- LIMITE DE LANCE/LANCE AUTOMATICO -->
            <!--
                            STATUSLEILAO_ID - 13 = VENDA_DIRETA
            -->
            <div v-if="leilao.statusleilao_id !== 13" class="lance-input-group add-label-lance add-label-limite">
              <div class="col-xs-8 container-input-lance">
                <input v-money="money" id="enviar_limite_lance_val" class="input-manual add-label-lance" value
                       v-model="valorLance"/>
              </div>
              <div class="col-xs-4 container-btn-lance">
                <button v-if="statusLote.statuslote == 'Vendido'" id="enviar_limite_lance"
                        class="btn-lance btn-lance-input" disabled="disabled"
                        style="'cursor:pointer;background: #515151 !important;cursor:no-drop;">
                  Ok
                </button>
                <button v-else id="enviar_limite_lance" class="btn-lance btn-lance-input" @click="enviaLimiteLance"
                        :disabled="!liberado || !liberacao_lote" :style="'cursor:pointer;' +
                    (!liberado || !liberacao_lote
                      ? 'background: #515151 !important;cursor:no-drop;'
                      : '')
                    ">
                  Ok
                </button>
              </div>

              <div class="row" style="float: left">
                <div class="col-md-12">
                  <label class="label-limite">Limite cadastrado:</label>
                  <label class="label-limite" style="color: #bd5e5e">
                    {{ lote.vl_lanceautomatico }} {{ lote.nu_parcelas }}
                    <span class="fa fa-close remove-limite" @click="removeLimiteLance"></span>
                  </label>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- self::VENDIDO, self::CONDICIONAL, self::NAO_VENDIDO, self::HOMOLOGADO, self::NAO_HOMOLOGADO  4 5 7 9  -->
            <div v-else>
              <!--Venda Direta-->
              <div v-show="statusLote.statuslote_id !== 4 &&
                statusLote.statuslote_id !== 5 &&
                statusLote.statuslote_id !== 7 &&
                statusLote.statuslote_id !== 9 &&
                !leilao.bn_aceitelanceparcelado
                " class="lance-input-group">
                <div class="lance-input-group add-label-lance add-label-manual">
                  <div class="col-xs-8 container-input-lance">
                    <input value v-money="money" id="enviar_lance_proposta" class="input-manual add-label-lance"/>
                  </div>
                  <div class="col-xs-4 container-btn-lance">
                    <button v-if="statusLote.statuslote == 'Vendido'" id="enviar_lance_manual"
                            class="btn-lance btn-lance-input" disabled="disabled" style="
                        cursor: pointer;
                        background: #515151 !important;
                        cursor: no-drop;
                      ">
                      Ok
                    </button>
                    <button v-else id="enviar_lance_manual" class="btn-lance btn-lance-input"
                            @click="enviaPropostaVendaDireta()" :disabled="!liberado || !liberacao_lote" :style="'cursor:pointer;' +
                        (!liberado || !liberacao_lote
                          ? 'background: #515151 !important;cursor:no-drop;'
                          : '')
                        ">
                      Ok
                    </button>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
          <div v-if="
            leilao.statusleilao_id !== 13 && !leilao.bn_aceitelanceparcelado
          " class="col-lg-4 col-padding-lance">
            <span class="label-span-help">
              Limite lance
              <span class="envia_limite_lance" title="O que é?" @click="limiteLanceMsg">?</span>
            </span>
          </div>
          <div v-else>
            <!--Venda Direta-->
            <div v-show="statusLote.statuslote_id !== 4 &&
              statusLote.statuslote_id !== 5 &&
              statusLote.statuslote_id !== 7 &&
              statusLote.statuslote_id !== 9 &&
              !leilao.bn_aceitelanceparcelado
              " class="col-md-4 col-lg-4 col-padding-lance">
              <span class="label-span-help">
                Enviar Proposta
                <span class="envia_limite_lance" title="O que é?" @click="propostaMsg">?</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="envio-area-lance">
        <div class="row">
          <div class="col-lg-12" style="font-size: 20px; color: #67302b !important">
            <span>
              <strong>Leilão com lances somente presenciais.</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="habilitacao_salaDisputa" v-for="(vistoria, id) in lote.vistoria" :key="id"
         v-show="vistoria.usuariovistorialotexstatusliberacaoextra != undefined"
         @click.prevent="liberacaoExtraMsg(vistoria.usuariovistorialotexstatusliberacaoextra), abreModal = !abreModal"
         title="requer habilitação especial neste lote, clique aqui para saber mais.">
      <img src="../../assets/portotemplate/img/fechadura.png" alt="fechadura de bloqueio habilitação especial">
      Requer habilitação especial
    </div>
  </div>
</template>

<script>
import LeilaoSocial from "@/components/shared/social/LeilaoSocial.vue";
import Countdown from "@/components/shared/Countdown.vue";
import ModalHAbilitacaoExtra from "./ModalHAbilitacaoExtra.vue";

export default {
  components: {
    ModalHAbilitacaoExtra,
    Countdown,
    LeilaoSocial,
  },
  props: [
    "lote",
    "leilao",
    "liberado",
    "isfavorito",
    'dadosLeilao',
    "usuario",
    "historico",
    "lanceAtual",
    "statusLote",
    "automatico",
    "dt_fechamento_lote",
    "liberacao_lote",
    "paramsite_proposta",
    "time",
    "isRunningOut",
    "historicoLances"
  ],
  data() {
    return {
      intervalLance: null,
      errors: [],
      qtdParcelas: 1,
      limite: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      showShare: false,
      parcelamento: 1,
      abreModal: false,
      info: '',
      diferencaPercentual: 0,
      nu_limitepercentualloteInicial: 0,
      saladisputa: false,
      tipoParcelamento: false,
      valorLance: 0
    };
  },
  watch: {
    'lote'(novo, ant) {
      if (novo) {
        this.qtdParcelas = 1;
        this.verificarTitoDeParcelamento();
        this.calcularDiferencaPercentual();
      }
    },
    $route(to, from) {
      this.valorLance = 0;
    }
  },
  methods: {
    calcularDiferencaPercentual() {
      this.nu_limitepercentualloteInicial = this.lote.nu_limitepercentuallote;

      if (!this.lote.vistoria || !this.lote.vistoria[0]) return;

      const val1 = parseFloat(this.lote.vistoria[0].vl_lanceinicial);
      const val2 = parseFloat(this.lote.vistoria[0].vl_lanceinicialsegundoleilao);

      if (isNaN(val1) || isNaN(val2)) return;

      const diferenca = val1 - val2;
      const percentual = (diferenca / val1) * 100;

      this.diferencaPercentual = percentual.toFixed(2);
    },
    getLink() {
      return window.location.href;
    },

    addFavorito() {
      this.$parent.$emit("addFavorito", this.Isfavorito);
    },

    enviarLance(val, tipo) {
      var valor = 0;
      var preferencia = window.localStorage.getItem('a5cc51388b67c5c132389a6ffc950dbf');

      if (val == true) {
        val = document.querySelector("#enviar_lance_manual_val").value;
        val = "R$ " + val;
      }
      valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");

      var isLance = true;
      if (tipo != "undefined") {
        if (tipo == "venda_direta") {
          isLance = false;
        }
      }

      const self = this;
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      let limiteParcelas = "";
      let parcelas = 1;

      if (
        this.leilao.bn_aceitelanceparcelado ||
        this.lote.bn_aceitelanceparceladolote
      ) {
        parcelas = document.querySelector("#limite_parcelas").value;
        limiteParcelas = `&nu_parcelas=${document.querySelector("#limite_parcelas").value
        }`;
        //lance trt
        if (this.lote.nu_intervaloparcelaslote == 4) {
          if (valor == this.lanceAtual.vl_lance && parcelas >= this.lanceAtual.nu_parcela) {
            alert(
              "Lance não foi registrado. O Lance enviado deve ser maior que o lance Atual!11"
            );
            return false;
          }
        } else if (this.lote.nu_intervaloparcelaslote == 5) {
          var percentuallote = self.lote.nu_limitepercentuallote;
          if (valor < this.lanceAtual.vl_lance || parcelas < this.lanceAtual.nu_parcela || percentuallote < this.lanceAtual.vl_percentualentrada) {
            alert(
              "Lance não foi registrado. O Lance enviado deve ser maior que o lance Atual!5_11"
            );
            return false;
          }
        } else {
          if (valor == this.lanceAtual.vl_lance && !preferencia.includes(self.usuario.id)) {
            alert(
              "Lance não foi registrado. O Lance enviado deve ser maior que o lance Atual!22"
            );
            return false;
          }
        }
      }

      let db = this.firebase_db;
      let usuarioIdLogado = null;
      let usuarioIdUltimoLance = null;

      db.ref(`/lance/${leilaoIdTratado}/${loteIdTratado}`)
        .orderByChild("id")
        .limitToLast(1)
        .once("value")
        .then(function (data) {
          usuarioIdLogado = self.usuario.id;

          if (data.val()) {
            usuarioIdUltimoLance = Object.values(data.val())[0].nm_usuario_id;
          }

          if (usuarioIdLogado === usuarioIdUltimoLance) {

            let textoModal = `<p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                              <p>${self.lote.nm_titulo}</p>
                              <p style="background-color: #f5f5f5; padding: 10px; border-radius: 5px; margin: 10px 0;">
                                <strong style="color: #512925;">Condições de Pagamento:</strong><br>
                                ${parcelas > 1
              ? `<span>Entrada: <strong>${self.lote.nu_limitepercentuallote}%</strong></span><br><span>Parcelas: <strong>${parcelas + 'x'}</strong></span><br>`
              : '<span>Pagamento: <strong>À Vista</strong></span><br>'
            }
                              </p>
                              <p style="display: flex; align-items: center; gap: 20px"> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${val}</strong></p>`;

            self.$modal.show("dialog", {
              title: `<strong style="font-size:20px;color: #512925;">Lote ${self.lote.nu}</strong>`,
              text: textoModal,
              buttons: [
                {
                  title: "NÃO",
                  handler: () => {
                    self.loading = false;
                    self.$modal.hide("dialog");
                  },
                },
                {
                  title: "SIM",
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide("dialog");
                    modalEnviaLance(
                      self,
                      hostName,
                      leilaoIdTratado,
                      loteIdTratado,
                      val,
                      valor,
                      limiteParcelas,
                      isLance
                    );
                  },
                },
              ],
            });
          } else {
            modalEnviaLance(
              self,
              hostName,
              leilaoIdTratado,
              loteIdTratado,
              val,
              valor,
              limiteParcelas,
              isLance
            );

          }
        });
    },

    limiteLanceMsg() {
      this.$modal.show("dialog", {
        title: `Limite de Lance`,
        text: `<p>O limite de lance possibilita que o usuário agende previamente o valor limite dos seus lances.</p>
                    <p>Dessa forma o usuário que não pode acompanhar o leilão simultaneamente tem a garantia de que seus lances serão enviados automaticamente até o valor estipulado pelo mesmo.</p>
                    <p>O sistema validará o lance a ser enviado de acordo com o valor de incremento do momento, sendo assim, caso o limite de lance cadastrado seja inferior ao valor do último lance + valor de incremento do momento, seu lance não será efetivado.</p>
                    <p><strong>Obs.</strong> O valor do limite do lance é confidencial.</p>
                    `,
        buttons: [
          {
            title: "Fechar",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },

    propostaMsg() {
      this.$modal.show("dialog", {
        title: `Envio de Proposta`,
        text: `<p>Ao enviar uma proposta, o leiloeiro irá receber uma notificação para avaliar o valor enviado e entrará em contato com o comprador.
                    <p><strong>Obs.</strong> O valor da proposta é confidencial.</p>
                    `,
        buttons: [
          {
            title: "Fechar",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },

    liberacaoExtraMsg(descricao) {
      this.info = descricao;
    },

    fechaModalLiberacaoExtra(valor) {
      this.abreModal = valor
    },

    enviaLimiteLance() {
      const val = document.querySelector("#enviar_limite_lance_val").value;
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
      const valorEnvioManual = document.querySelector("#enviar_lance_manual_val").value.replace(/\./g, "").replace("R$ ", "").replace(",", ".");

      const incremento = parseFloat(this.lote.raw_incremento);

      const valorMinimoPermitido = parseFloat(valorEnvioManual) + incremento;

      if (parseFloat(valor) < valorMinimoPermitido) {
        document.querySelector("#enviar_limite_lance_val").value = this.$root.formatarPreco(valorMinimoPermitido)
        return alert(`Limite de lance deve ser maior ou igual ao lance atual mais o incremento: ${this.$root.formatarPreco(valorMinimoPermitido)}`);
      } else {
        this.abrirModalEnvioLimiteLance(valor);
      }
    },

    abrirModalEnvioLimiteLance(valor) {
      const val = valor
      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      let limiteParcelas = "";
      let parcelas = 1;
      if (
        self.leilao.bn_aceitelanceparcelado ||
        self.lote.bn_aceitelanceparceladolote
      ) {
        parcelas = document.querySelector("#limite_parcelas").value;
        limiteParcelas = `&nu_parcelas=${document.querySelector("#limite_parcelas").value
        }`;
      }

      let nmDescricao = "";

      if (
        (self.leilao.bn_aceitelanceparcelado || self.lote.bn_aceitelanceparceladolote) &&
        this.nu_limitepercentualloteInicial &&
        this.nu_limitepercentualloteInicial !== '0' &&
        parcelas > 1
      ) {
        nmDescricao += '<p>ATENÇÃO: Para lances automáticos, a porcentagem de entrada considerada será de ' + this.nu_limitepercentualloteInicial + '%</p>';
      }

      nmDescricao += "<p>Confirma o limite de lance ";

      if (parcelas > 1) {
        nmDescricao += ` Parcelado em ${parcelas}x ? </p>`;
      } else {
        nmDescricao += ` à vista ? </p>`;
      }

      let textoModal =
        `  <p>${self.lote.nm_titulo}</p> ` +
        nmDescricao +
        `  <p> Valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">${Number(val).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        })}</strong></p>`;

      self.$modal.show("dialog", {
        title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
        text: textoModal,
        buttons: [
          {
            title: "Cancelar",
            handler: () => {
              self.$modal.hide("dialog");
            },
          },
          {
            title: "Enviar limite",
            default: true, // HABILITAR BOTÃO ENTER
            handler: async () => {
              self.loading = true;
              await this.removeLimiteLanceSuperado();
              await fetch(`${hostName}/leilao/envialanceauto?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0${limiteParcelas}&firebase=1`, {method: 'POST'})
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  clearInterval(this.intervalLance);
                  if (res.erro == true) {
                    self.errors.push(res);
                    alert(self.$root.decodeHtml(res.msg_erro));
                    self.$modal.hide("dialog");
                  } else {
                    localStorage.setItem(
                      "valor_limite_lote" + self.$route.params.idlote,
                      val
                    );
                    this.intervalLance = this.verificaLanceAutomatico();
                  }
                  self.$parent.$emit("callDadosGerais");

                  this.valorLance = 0.00;
                  self.$modal.hide("dialog");
                })
                .catch((e) => {
                  this.valorLance = 0.00;
                  self.errors.push(e);
                  self.$modal.hide("dialog");
                });
            },
          },
        ],
      });
    },

    removeLimiteLance() {
      const val = this.lote.vl_lanceautomatico;
      if (!val) {
        return;
      }
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      self.$modal.show("dialog", {
        title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
        text: ` <p>${self.lote.nm_titulo}</p>
                            <p>Remover o limite de lance? </p>
                            <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">${val}</strong> </p>`,
        buttons: [
          {
            title: "Cancelar",
            handler: () => {
              self.$modal.hide("dialog");
            },
          },
          {
            title: "Remover Limite",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              self.loading = true;

              fetch(
                `${hostName}/leilao/removelanceauto/leilao_id/${leilaoIdTratado}/lote_nu/${self.lote.nu}?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0&firebase=1`
              )
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  if (res.erro == true) {
                    self.errors.push(res);
                    alert(self.$root.decodeHtml(res.msg_erro));
                    self.$modal.hide("dialog");
                  }

                  self.$parent.$emit("callDadosGerais", self);

                  // FECHA MODAL E PARA O LOADING
                  self.$modal.hide("dialog");
                })
                .catch((e) => {
                  self.errors.push(e);
                  self.$modal.hide("dialog");
                });
            },
          },
        ],
      });
    },

    removeLimiteLanceSuperado() {
      const val = this.lote.vl_lanceautomatico;
      if (!val) {
        return;
      }
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      self.loading = true;

      fetch(
        `${hostName}/leilao/removelanceauto/leilao_id/${leilaoIdTratado}/lote_nu/${self.lote.nu}?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0&firebase=1`
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((res) => {
          if (res.erro == true) {
            self.errors.push(res);
          }

          self.$parent.$emit("callDadosGerais", self);
        })
        .catch((e) => {
          self.errors.push(e);
        });
    },

    removeLimiteLanceAtingido() {
      const parseValor = (valor) => {
        if (typeof valor !== 'string') return null;

        if (valor.startsWith("R$ ")) {
          valor = valor.replace(/\./g, "").replace("R$ ", "");
        }

        valor = valor.replace(",", ".");

        return parseFloat(valor);
      };

      const checkAndRemoveLimit = async () => {
        var vllance = this.lanceAtual && this.lanceAtual.vl_lance ? parseValor(this.lanceAtual.vl_lance) : null;
        var vllanceautomatico = this.lote && this.lote.vl_lanceautomatico ? parseValor(this.lote.vl_lanceautomatico) : null;

        if (vllance !== null && vllanceautomatico !== null && vllance > vllanceautomatico) {
          clearInterval(interval);
          await this.removeLimiteLanceSuperado();
          await this.removeLimiteLanceAtingido();
        }
      };

      const interval = setInterval(checkAndRemoveLimit, 2000);
    },

    enviaPropostaVendaDireta() {
      const val = document.querySelector("#enviar_lance_proposta").value;
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      const vl_percentual = 90;
      const percentual_proposta =
        (self.lote.vl_lanceinicial * vl_percentual) / 100;

      if (valor < percentual_proposta) {
        alert(
          "Sua proposta deve ser no minimo " +
          vl_percentual +
          "% do valor inicial: " +
          self.$root.formatarPreco(self.lote.vl_lanceinicial)
        );
        return false;
      }

      self.$modal.show("dialog", {
        title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
        text: ` <p>${self.lote.nm_titulo}</p>
                            <p>Confirma a proposta de lance? </p>
                            <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">R$ ${val}</strong> </p>`,
        buttons: [
          {
            title: "Cancelar",
            handler: () => {
              self.$modal.hide("dialog");
            },
          },
          {
            title: "ENVIAR PROPOSTA",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              self.loading = true;

              fetch(`${hostName}/leilao/enviaproposta?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}`, {method: 'POST'})
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  if (res.erro == true) {
                    self.errors.push(res);
                    alert(self.$root.decodeHtml(res.msg_erro));
                    document.querySelector("#enviar_lance_proposta").value = "";
                    self.$modal.hide("dialog");
                  }

                  self.$parent.$emit("callDadosGerais");

                  document.querySelector("#enviar_lance_proposta").value = "";
                  self.$modal.hide("dialog");
                  alert(
                    "Sua proposta foi enviada com sucesso. Em breve um de nossos atendentes entrará em contato para dizer se sua proposta foi aceita. Qualquer dúvida por favor entrar em contato via telefone. Obrigado."
                  );
                })
                .catch((e) => {
                  document.querySelector("#enviar_lance_proposta").value = "";
                  self.errors.push(e);
                  self.$modal.hide("dialog");
                });
            },
          },
        ],
      });
    },

    async verificarTitoDeParcelamento() {
      this.tipoParcelamento = await this.tipoParcelamentos
      this.saladisputa.tipoParcelamento(this.lote.leilao_id, this.lote.lote_id);
    },

    verificaLanceAutomatico() {
      setInterval(() => {
        var valor_limite_lote = localStorage.getItem(
          "valor_limite_lote" + this.$route.params.idlote
        );
        if (
          this.usuario_id_logado !== this.usuario_id_ultimolance &&
          this.valor_limite_lote >= this.lanceAtual.vl_lance_sugerido
        ) {
          this.enviarLanceAutomatico(this.lanceAtual.vl_lance_sugerido);
        }
      }, 10000);
    },

    enviarLanceAutomatico(valorLance) {
      var url = `${location.protocol + "//" + window.HOSTNAME
      }/leilao/envialance/?ajax=1&leilao_id=${this.$route.params.id}&lote_id=${this.$route.params.idlote
      }&vl_lance=${this.lanceAtual.vl_lance_sugerido}&force=0${this.limiteParcelas ? this.limiteParcelas : 0
      }&firebase=1&automatico=1`;
      fetch(url, {method: 'POST'})
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((res) => {
          document.querySelector("#enviar_lance_manual_val").value = valorLance;

          if (res.dados_lote) {
            document.querySelector("#enviar_lance_manual_val").value =
              valorLance;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    igualarLanceAtual() {
      let val = this.$root.formatarPreco(this.lanceAtual.vl_lance);
      let valorFormatado = val
        .replace(/\./g, "")
        .replace("R$ ", "")
        .replace(",", ".");
      this.$modal.hide("dialog");
      this.$modal.show("dialog", {
        title: `<strong style="font-size:20px;color: #512925;">Lote ${this.lote.nu}</strong>`,
        text: ` <p style="color: red;"><strong>VOCÊ DESEJA IGUALAR O VALOR ATUAL DE MANEIRA À VISTA?</strong></p>
                                    <p>${this.lote.nm_titulo}</p>
                                    <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${val}</strong> </p>`,
        buttons: [
          {
            title: "CANCELAR",
            handler: () => {
              this.loading = false;
              this.$modal.hide("dialog");
            },
          },
          {
            title: "ENVIAR",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              this.loading = true;

              fetch(`${location.protocol + "//" + window.HOSTNAME}/leilao/envialance/?ajax=1&leilao_id=${this.$route.params.id}&lote_id=${this.$route.params.idlote}&vl_lance=${valorFormatado}&force=0${1}&firebase=1`, {method: 'POST'})
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  if (res.erro == true) {
                    this.errors.push(res);
                    alert(this.$root.decodeHtml(res.msg_erro));
                    document.querySelector("#enviar_lance_manual_val").value =
                      this.lote.vl_lance_sugerido;
                  }
                  if (res.dados_lote) {

                    document.querySelector("#enviar_lance_manual_val").value =
                      res.dados_lote.vl_lance_sugerido;
                  }
                  // FECHA MODAL E PARA O LOADING
                  this.$modal.hide("dialog");
                })
                .catch((e) => {
                  this.$modal.hide("dialog");
                  this.errors.push(e);
                });
            },
          },
        ],
      });
    },

    async calcParcelamento(lote) {
      await this.firebase_db.ref(`/lote/${lote.leilao_id}/${lote.lote_id}`).once("value", function (data) {
        lote = data.val();
      });

      var valor = document.querySelector("#enviar_lance_manual_val").value;
      this.parcelamento = lote.nu_limiteparcelaslote ? this.$root.refreshParcelamento(lote, valor) : 1;
      this.lote.nu_limitepercentuallote = this.nu_limitepercentualloteInicial;
    },

    incrementarPercentual() {
      if (this.lote.nu_limitepercentuallote < 100) {
        this.lote.nu_limitepercentuallote += 1;
      }
    },

    decrementarPercentual() {
      if (this.lote.nu_limitepercentuallote > this.nu_limitepercentualloteInicial) {
        this.lote.nu_limitepercentuallote -= 1;
      }
    }

  },

  created() {
    //this.parcelamento = 2;
    this.removeLimiteLanceAtingido();
    this.verificarTitoDeParcelamento()
    this.saladisputa = new window.saladisputa(this);
  },
  destroyed() {
    clearInterval(this.intervalLance);
  },
};

function modalEnviaLance(
  self,
  hostName,
  leilaoIdTratado,
  loteIdTratado,
  val,
  valor,
  limiteParcelas,
  isLance,
  igualarlanceavista
) {
  let percentuallote = self.lote.nu_limitepercentuallote;
  var nmDescricao = "<p>Confirmar o envio de lance";
  if (isLance == false) {
    nmDescricao = "<p>Confirmar a venda direta";
    if (self.paramsite_proposta.bn == true) {
      nmDescricao = "<p>Confirmar o lance condicional";
    }
  }
  let parcelas = 1;
  if (
    self.leilao.bn_aceitelanceparcelado ||
    self.lote.bn_aceitelanceparceladolote
  ) {
    parcelas = document.querySelector("#limite_parcelas").value;
  }

  if (parcelas > 1 && !igualarlanceavista) {
    nmDescricao += ` Parcelado em ${parcelas}x ?</p>`;
  } else {
    nmDescricao += ` à vista ?</p>`;
  }

  const domainParts = window.location.hostname.split('.');
  let mainDomain = '';

  if ((domainParts[0] === 'dev' || domainParts[0] === 'teste') && domainParts[1] !== 'vue') {
    mainDomain = domainParts[1];
  } else if (domainParts[0] === 'dev' && domainParts[1] === 'vue') {
    mainDomain = domainParts[2];
  } else if (domainParts[0] === 'www') {
    mainDomain = domainParts[1];
  } else {
    mainDomain = domainParts[0];
  }

  let leiloeiroSelect = '';

  if (mainDomain === 'sobrasdosleiloesdeimoveis') {
    let leiloeiroSalvo = sessionStorage.getItem('leiloeiroSelecionado') || '';
    leiloeiroSelect = '<select id="select_leiloeiro" style="width:100%;padding:8px;margin-top:10px;">' +
      '<option value="">Selecionar o leiloeiro</option>';

    const leiloeirosVinculados = (self.dadosLeilao && self.dadosLeilao.leiloeirovinculado) ? self.dadosLeilao.leiloeirovinculado : [];

    leiloeirosVinculados.forEach(leiloeiro => {
      let selected = (leiloeiro.leiloeiro_id === Number(leiloeiroSalvo)) ? 'selected' : '';
      leiloeiroSelect += `<option value="${leiloeiro.leiloeiro_id}" ${selected}>${leiloeiro.nm_leiloeiro}</option>`;
    });

    leiloeiroSelect += '</select>';
  }

  let textoModal =
    ` <p>${self.lote.nm_titulo}</p>
      <p style="color: #512925; font-size: 18px; margin-bottom: 5px;"><strong>${nmDescricao.replace('<p>', '').replace('</p>', '')}</strong></p>
      <div style="background-color: #f5f5f5; padding: 10px; border-radius: 5px; margin: 10px 0;">
        <strong style="color: #512925;">Condições de Pagamento:</strong><br>
        ${parcelas > 1
      ? `<span>Entrada: <strong>${percentuallote}%</strong></span><br><span>Parcelas: <strong>${parcelas + 'x'}</strong></span><br>`
      : '<span>Pagamento: <strong>À Vista</strong></span><br>'
    }
      </div>
      ${leiloeiroSelect}
      <p style="display: flex; align-items: center; gap: 20px; margin-top: 15px;">valor :
        <strong style="font-weight:800 !important; font-size:30px; color: #3b8119;">${val}</strong>
      </p>`;

  self.$modal.show("dialog", {
    title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
    text: textoModal,
    buttons: [
      {
        title: "Cancelar",
        handler: () => {
          self.$modal.hide("dialog");
        },
      },
      {
        title: "Enviar",
        default: true, // HABILITAR BOTÃO ENTER
        handler: () => {
          const leiloeiroSelectElement = document.getElementById('select_leiloeiro');
          let leiloeiroId = '';
          if (leiloeiroSelectElement) {
            leiloeiroId = leiloeiroSelectElement.value;
            if (!leiloeiroId) {
              alert('Por favor, selecione um leiloeiro antes de enviar o lance.');
              self.loading = false;
              return;
            }
            sessionStorage.setItem('leiloeiroSelecionado', leiloeiroId);
          }

          self.loading = true;

          const headers = {
            'Content-Type': 'application/json'
          };

          const token = window.localStorage.getItem('token');
          if (token) {
            headers['Authorization'] = `Bearer ${token}`;
          }

          let url_post = `${hostName}/leilao/envialance/?ajax=1&leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0${limiteParcelas}&firebase=1&percentuallote=${percentuallote}`;

          if (leiloeiroId) {
            url_post += `&leiloeiro_id=${leiloeiroId}`;
          }

          fetch(url_post, {
            method: 'POST',
            headers: headers
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
              }
              return res.json();
            })
            .then((res) => {
              if (res.erro == true) {
                self.errors.push(res);
                alert(self.$root.decodeHtml(res.msg_erro));
                document.querySelector("#enviar_lance_manual_val").value =
                  this.lote.vl_lance_sugerido;
              }
              if (res.dados_lote) {

                document.querySelector("#enviar_lance_manual_val").value =
                  res.dados_lote.vl_lance_sugerido;
              }
              // FECHA MODAL E PARA O LOADING
              self.$modal.hide("dialog");
            })
            .catch((e) => {
              self.$modal.hide("dialog");
              self.errors.push(e);
            });
        },
      },
    ],
  });
}
</script>

<style>
/* area de lance */
.header-area-lance h1 {
  font-weight: 600 !important;
  padding-right: 30px;
  /*text-align: justify;*/
}

h1.title-header-area {
  font-size: 35px !important;
  padding: 3px 0;
  font-weight: 300 !important;
  color: #62615a !important;
  position: relative;
}

.hasPortions {
  margin-bottom: 0 !important;
}

.portion {
  font-size: 18px;
  width: 100%;
  margin-left: 2px !important;
  color: red;
}

.lance-atual-header {
  font-size: 13px;
  color: #2c672b;
  font-weight: bold;
  position: relative;
  top: 8px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.btn-lance {
  padding: 12px;
  font-size: 20px !important;
  background: #67302b;
  color: #fff;
  border: 1px solid rgb(81, 81, 81);
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
}

.label-span-help {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #d6d6d6;
  display: block;
  text-align: center;
  font-size: 12px;
  position: relative;
  padding: 7px 29px 11px 33px;
  text-align: left;
}

.label-span-help:before {
  content: "";
  width: 0;
  height: 0;
  border: 7px solid #000;
  position: absolute;
  top: -0.4px;
  left: -17px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
  border-right: 12px solid #d6d6d6;
}

.btn-lance:hover {
  background: #438855;
  border: 1px solid #438855;
}

.input-manual {
  padding: 12px;
  font-size: 20px !important;
  border: 1px solid #ccc;
  width: 100%;
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-lance-input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.container-input-lance {
  padding: 0 !important;
}

.container-btn-lance {
  padding: 0 !important;
}

.lance-input-group {
  margin: 15px 0 0;
}

.col-padding-lance {
  padding: 14px 0;
}

button {
  margin: 0 !important;
}

button:disabled,
button:disabled .text {
  pointer-events: all !important;
}

button:disabled {
  opacity: 1 !important;
}

.countdown {
  padding: 0 14px !important;
  margin: -1px -5px -11px -9px;
}

.add-favorito-novo {
  text-align: right;
  font-size: 20px;
  cursor: pointer;
  border-radius: 30px;
  padding: 6px 4px 4px 6px;
  background: #fff;
  box-shadow: 1px 1px 1px #ccc;
}

.box-heart {
  max-width: 30px;
}

.box-circle {
  border-radius: 30px;
  padding: 6px 4px 4px 5px;
  background: #fff;
  box-shadow: 1px 1px 1px #ccc;
}

.inline-flex {
  display: inline-flex;
}

.share-buttons {
  visibility: hidden;
  opacity: 0;
  transition: all 1s ease;
  left: 0;
  margin-left: -100px;
}

.share-buttons-on {
  visibility: visible;
  opacity: 1;
  left: 100%;
  margin-left: 4px;
}

.pointer {
  cursor: pointer;
}

.box {
  margin-left: 7px;
  max-width: 30px;
  margin-bottom: 10px;
}

.habilitacao_salaDisputa {
  display: flex;
  text-align: center;
  justify-content: center;
  font-size: 18px;
  background: #d6d6d6;
  color: #000;
  height: 50px;
  border-radius: 5px;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  transition: .3s;
}

.habilitacao_salaDisputa:hover {
  background: #b3b3b3;
}

.habilitacao img {
  margin-right: 5px;
}

.vl-lanceinicial,
.vl-avaliacao,
.base_desconto_segundoleilao {
  font-size: 1.2em;
}

.vl-lanceinicial,
.base_desconto_segundoleilao {
  font-weight: bold;
}

.base_desconto_segundoleilao {
  color: red;
}

.product-info__lote-info {
  font-size: 1.3em;
}

.indice-correcao {
  font-size: 14px;
}

@media (max-width: 980px) {
  .label-span-help {
    margin-top: -12px;
    padding: 10px;
    text-align: center;
  }

  .label-span-help:before {
    display: none;
  }
}

@media (max-width: 600px) {
  .lt-lance {
    padding: 22px !important;
  }

  .vl-lanceinicial,
  .vl-avaliacao,
  .base_desconto_segundoleilao {
    font-size: 1.1em;
  }
}

/*.product-info {*/
/*max-width: 100%;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/shared/AreaLance.vue